import H from '@tracsis/library/src/components/Typography/H';
import { ThemeContext } from '@tracsis/library/src/context/ThemeContext';
import cx from 'classnames';
import { Link } from 'gatsby';
import React, { useContext } from 'react';

import { TracsisLogoGhost } from '../../../index';
import { Facebook, Instagram, LinkedIn, TikTok, X } from '../../Icon/index';
import { ISocialLink } from '../Layout/Layout';
import * as styles from './MinimalFooter.module.css';

const MinimalFooter = ({
	logo,
	social,
	isGroup = false,
	footerContent,
}: {
	logo?: React.ReactNode;
	social?: ISocialLink[];
	isGroup?: boolean;
	footerContent: React.ReactNode;
}) => {
	const { variant } = useContext(ThemeContext);
	return (
		<footer className={cx(styles.footer, styles[variant])}>
			<div className={styles.layout}>
				{logo && (
					<Link to={'/'} className={styles.logo}>
						{logo}
					</Link>
				)}
			</div>

			<div className={styles.columnsWrapper}>
				<H level={6} color="white">
					Contact
				</H>

				<div className={styles.layoutColumns}>
					{footerContent && <div>{footerContent}</div>}

					{social && (
						<nav>
							<ul>
								{social.map(({ platform, to }, key: number) => (
									<li key={key}>
										<a href={to} target="_blank" className={styles.platform}>
											<span className={styles.socialIcon}>
												{
													{
														LinkedIn: <LinkedIn />,
														X: <X />,
														Facebook: <Facebook />,
														Instagram: <Instagram />,
														TikTok: <TikTok />,
													}[platform]
												}
											</span>
											{platform}
										</a>
									</li>
								))}
							</ul>
						</nav>
					)}
				</div>
			</div>

			<div className={styles.layout}>
				<div className={styles.copyright}>
					<div className={styles.small}>
						<p>Website by <a href="https://majordigital.com">MAJOR</a>. | Copyright &copy; {new Date().getFullYear()} Tracsis plc</p>
					</div>

					{!isGroup && (
						<div className={styles.groupLogo}>
							<TracsisLogoGhost />
						</div>
					)}
				</div>
			</div>
		</footer>
	);
};

export default MinimalFooter;
